import React from "react";
import { BsSearch } from "react-icons/bs";

export default function NoResults() {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="mb-2">
        <BsSearch />
      </div>
      <div className="text-gray-600">No Records Found</div>
    </div>
  );
}
